import React from "react"

export function List({ children }: { children?: React.ReactNode }): JSX.Element {
    return <ul className="component--list">{children}</ul>
}
